import React, { useRef } from "react";
import { Modal } from "../../../Common/fModal/Modal";
import { FloatInput } from "../../../Common/Class/FloatLabelInput";
import { showToast } from "../../../Common/fToast/ToastCallback";

const ConfirmationModal = ({ onClose, onSave }) => {
    const remarkRef = useRef()
    return (
        <Modal
            title={'Withdraw GIN'}
            buttonName={'Withdraw'}
            des="Are you sure wants to withdraw gin?"
            close={onClose}
            onSave={() => {
            let remarks = remarkRef.current.getValue()
             if(!remarks){
                 showToast({
                     type: 'error',
                     message: "Please enter the remarks"
                 })
                 return;
             }
             onSave(remarks)
            }}
            show={true}
            style={{
                save: {
                    background: "var(--red-color)",
                    border: "2px solid var(--red-color)",
                    padding: '8px 15px',
                    width: '100%',
                    textAlign: 'center'
                }
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FloatInput type="text" title="Enter Remarks" handleRef={ref => remarkRef.current = ref} />
            </div>
        </Modal>
    )
}
export default ConfirmationModal